import { Link } from "react-router-dom";
import "./breadcrumb.css";

export default function Breadcrumb({ current }) {
  return (
    <nav className="oglitz-breadcrumb" aria-label="Breadcrumb">
      <Link to="/">Home</Link>
      <span>/</span>
      <span>{current}</span>
    </nav>
  );
}
